import { createApiMutation, createApiQuery } from '@/features/api'

import type { CategoryFormDto } from './components/item-category-form'
import type {
	IItemCategory,
	IItemFormPayload,
	IItemMaster,
	IItemMasterWithOutletData,
	IItemOutlet,
	IItemPurchase,
	IItemPurchasePayload,
} from './type'

/* ------------------------------- ITEM MASTER ------------------------------ */

export const itemMasterList = createApiQuery<{
	params: { outletId: string }
	result: { items: Array<IItemMaster> }
}>('/item/master/list')

export const itemMasterDetail = createApiQuery<{
	params: { id: string }
	result: { item: IItemMasterWithOutletData }
}>('/item/master/detail')

export const itemMasterCreate = createApiMutation<{
	body: IItemFormPayload
}>('/item/master/create', { method: 'post' })

export const itemMasterUpdate = createApiMutation<{
	body: IItemFormPayload & { id: string }
	id: string
}>('/item/master/update', { method: 'put' })

// ASSIGN TO OUTLET
export const itemMasterAssignToOutlet = createApiMutation<{
	body: { outletId: string; imIds: string[] }
	result: { ioIds: string[] }
}>('/item/master/assign-to-outlet', { method: 'post' })

/* ------------------------------- ITEM OUTLET ------------------------------ */

// LIST
export const itemOutletList = createApiQuery<{
	params: { outletId: string }
	result: { items: Array<IItemOutlet> }
}>('/item/outlet/list')

/* ------------------------------ ITEM CATEGORY ----------------------------- */

// LIST
export const itemCategoryList = createApiQuery<{
	result: { categories: Array<IItemCategory> }
}>('/item/category/list')

// DETAIL
export const itemCategoryDetail = createApiQuery<{
	params: { id: string }
	result: { category: IItemCategory }
}>('/item/category/detail')

// CREATE
export const itemCategoryCreate = createApiMutation<{
	body: CategoryFormDto
}>('/item/category/create', { method: 'post' })

// UPDATE
export const itemCategoryUpdate = createApiMutation<{
	body: CategoryFormDto & { id: string }
}>('/item/category/update', { method: 'put' })

/* ------------------------------ ITEM PURCHASE ----------------------------- */

export const itemPurchaseList = createApiQuery<{
	params: { outletId: string }
	result: { purchases: (IItemPurchase & IMetadata)[] }
}>('/item/purchase/list')

// Create
export const itemPurchaseCreate = createApiMutation<{
	body: IItemPurchasePayload
	result: { id: string }
}>('/item/purchase/create', { method: 'post' })
